/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

// Pages inside a trashed project must show all entities (trashed and not),
// so the default filter{trash}=false is stripped from every request
// while such a project is open.

let currentProjectTrashed = false;

export const setCurrentProjectTrashed = (trashed) => {
    currentProjectTrashed = Boolean(trashed);
};

const stripTrashFalseFromUrl = (url) => {
    const [path, query] = url.split("?");
    if (!query) return url;
    const kept = query
        .split("&")
        .filter(
            (param) =>
                param !== "" &&
                param !== "filter{trash}=false" &&
                param !== "filter%7Btrash%7D=false"
        );
    return kept.length ? `${path}?${kept.join("&")}` : path;
};

export const removeTrashFilterInterceptor = (config) => {
    if (!currentProjectTrashed) return config;

    if (typeof config.url === "string") {
        config.url = stripTrashFalseFromUrl(config.url);
    }
    if (config.params) {
        const value = config.params["filter{trash}"];
        if (value === false || value === "false") {
            delete config.params["filter{trash}"];
        }
    }
    return config;
};
